module.exports = __webpack_public_path__ + "static/media/stat547u_lecture05.6463caa6.pdf";